import { SVGProps } from "react";

const RefreshIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 25, stroke = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_458_20774"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="3"
        width="20"
        height="20"
      >
        <path
          d="M18 10.4679H22V3.4679H2V22.4679H11.0107V19.4106H13.0022V22.4679H17.0607L14.8242 18.8781L16.5195 17.8156L19.4289 22.4679H22V18.4575L17.7891 16.4093L18.6641 14.6085L22 16.2226V12.4679H18V10.4679Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_458_20774)">
        <path
          d="M20 12.4679C20 16.8862 16.4183 20.4679 12 20.4679C7.58172 20.4679 4 16.8862 4 12.4679C4 8.04962 7.58172 4.4679 12 4.4679C14.3894 4.4679 16.5341 5.51541 18 7.17625"
          stroke={stroke}
          strokeWidth="1.2"
        />
      </g>
      <path
        d="M20.4 4.91642V9.8679H15.4485L20.4 4.91642Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default RefreshIcon;
